import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app'
import baseStyles from './theme/base-style';
import defaultTheme from './theme/default-theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyles styles={baseStyles}/>
      <CssBaseline/>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
